<template>
  <div class="productaddons">
    <div class="pbottom-20">
      <div class="searchbox float-left">
        <input type="text"
               :placeholder="$t('Action.search')"
               v-model="filters.search"
               autocomplete="off"
               v-on:keyup="updateSearch"
               v-on:keyup.enter="handleInput"
        />
        <button class="btn-search"><i class="fa fa-search"></i></button>
      </div>
      <div class="float-right category-button" v-if="categories.length > 1" v-show="!categoryPicker || filters.category">
        <field name="category" type="select" v-model="filters.category" :options="categories" field-class="filter-field" v-on:input="handleInput"></field>
        <div v-if="categoryPicker" class="category-btn-overlay" @click="handleCategoryClick"></div>
      </div>
      <div class="clear"></div>
    </div>

    <pagedlist
      v-if="!categoryPicker || filters.category || filters.search"
      :offset="filters.offset"
      :limit="filters.limit"
      :count="filters.count"
      :pages="filters.pages"
      :loader="itemsLoader"
      v-on:refresh="refresh"
    >
      <table class="datatable table table-striped primary dataTable no-footer">
        <thead>
          <tr>
            <th>{{ $t('Common.itemName') }}</th>
            <th>{{ $t('Common.itemNum') }}</th>
            <th>{{ $t('Common.singlePrice') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in table.body">
            <td>
              <a v-on:click="handleItemClick(item)">
                <div class="product-addon mright-15">
                  <i class="fa fa-archive" v-if="!item.image"></i>
                  <img v-else :alt="item.itemnum" :src="productImageUrl(item)" />
                </div>
                {{item.name}}
              </a>
            </td>
            <td>{{ item.itemnum }}</td>
            <td>{{ item.sellingprice | formatCurrency }}</td>
          </tr>
        </tbody>
      </table>
    </pagedlist>

    <div v-if="categoryPicker" v-show="!filters.category && !filters.search" class="category-picker">
      <card
        :loader="categoryLoader"
        body-class="no-padding category-items"
      >
        <div class="category-item" v-for="category in categories.slice(1)" :style="`background-image: url(${categoryImage(category)})`" @click="updateCategory(category)">
          {{$t(category.label)}}
        </div>
      </card>
    </div>
  </div>
</template>
<script>
var view = require('../view.js'),
    viewData = {
      filters: {
        search: '',
        category: '',
        offset: 0,
        limit: 15,
        count: 0,
        pages: 0,
        locale: null
      },
      table: {
        body: []
      },
      itemsLoader: '',
      categoryLoader: '',
      categories: [
          {
            value: '',
            label: 'OrderDetails.allCategories'
          }
      ]
    };

export default view(viewData, {
  props: {
    categoryPicker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasItems() {
      return this.items.length > 0;
    }
  },
  methods: {
    async refresh(offset) {
      if (this.categories.length <= 1) {
        this.loadCategories();
      }

      this.itemsLoader = this.$t('Common.loading');
      this.$forceUpdate();

      if (offset != null)
        viewData.filters.offset = offset;

      viewData.filters.locale = this.$i18n.locale;

      viewData.table.body = [];
      const {data} = await this.$http.get(this.$root.url + 'item/', {params: viewData.filters});
      const {result} = data;
      viewData.table.body = result.data;
      viewData.filters.count = result.count;
      viewData.filters.offset = result.offset;
      viewData.filters.limit = result.limit;
      viewData.filters.pages = result.pages;
      this.itemsLoader = '';
    },
    async loadCategories() {
      this.categoryLoader = this.$t('Common.loading');
      this.$forceUpdate();
      const {data} = await this.$http.get(this.$root.url + 'item/tags')
      this.categoryLoader = '';
      this.categories = viewData.categories.slice(0);
      for (let item of data.result ?? []) {
        this.categories.push({
          value: item.name,
          label: item.name
        });
      }
      this.$forceUpdate();
    },
    productImageUrl({image, ID}) {
      return image ? (this.$root.url + 'item/img/' + ID) : undefined;
    },
    handleItemClick(item) {
      this.$emit('itemclick', item);
    },
    handleInput() {
      clearTimeout(this.timeout);
      this.refresh(0);
    },
    updateSearch() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.refresh(0), 700);
    },
    updateCategory(category) {
      this.filters.category = category.value;
      this.refresh(0);
    },
    handleCategoryClick() {
      if (this.categoryPicker) {
        this.filters.category = null
        this.filters.search = null
      }
    },
    categoryImage(category) {
      const base = (category.value || 'unknown')
              .replace(/Ä/g, 'Ae')
              .replace(/Ü/g, 'Ue')
              .replace(/Ö/g, 'Oe')
              .replace(/ä/g, 'ae')
              .replace(/ü/g, 'ue')
              .replace(/ö/g, 'oe')
              .replace(/ß/g, 'ss')
              .replace(/\s/gi, '_')
              .replace(/[^A-Za-z0-9_\-]/gi, '-');
      return `/img/category/${base}.png`;
    }
  }
});
</script>
<style>
  .productaddons {
    position: relative;
    min-height: 500px;
  }

  .category-picker {
  }

  .category-items {
    min-height: 150px;
  }

  .category-item {
    display: inline-block;
    flex: 0;
    width: 210px;
    margin: 10px;
    border: 1px solid gray;
    padding: 10px;
    padding-top: 200px;

    background: center top no-repeat;
    background-size: contain;

    text-align: center;
    cursor: pointer;
  }

  .category-button {
    position: relative;
  }

  .category-btn-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    z-index: 1;
  }
</style>
